import React, { ComponentType } from "react"

import BlogImage from "../blog-image"

const blockMap = {
  DatoCms_ImageRecord: BlogImage,
} as const

type BlockMap = typeof blockMap
type BlockKey = keyof BlockMap
type SpecificProps<K extends BlockKey> = Parameters<BlockMap[K]>[0]

export type BlockProps = {
  [K in BlockKey]: SpecificProps<K> & {
    __typename: K
    id: string
  }
}[BlockKey]

function Block(record: BlockProps) {
  const { __typename: typename } = record
  const Component = blockMap[typename] as ComponentType<BlockProps>
  return <Component {...record} />
}

export default Block
